<template>
  <div>
    <span class="sr-only">*</span>
    <span>
      <svg
        style="scale:100%;"
        class="hide heading-size inline-block animate-[spin_5s_linear_infinite] fill-flax-smoke-900"
        viewBox="0 0 75 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.668 75.939V64.59l4.073-16.005-12.513 11.64-9.894 5.529L.022 49.167l9.603-5.529L25.921 38.4 9.625 33.453.022 27.924l9.312-16.587 9.894 5.529 12.513 11.64-4.073-16.296V.861h19.206V12.21L42.8 28.506l12.513-11.64 9.894-5.529 9.312 16.587-9.604 5.529L48.62 38.4l16.296 5.238 9.604 5.529-9.313 16.587-9.894-5.529L42.8 48.585l4.074 16.005v11.349H27.666Z"
        ></path>
      </svg>
    </span>
  </div>
</template>
